module.exports = __webpack_public_path__ + "img/screenshot-device-empty-mark.c8c8e00a.jpg";